import { apiClient } from '../apiClient';

export const getFavorites = async () => {
  const response = await apiClient.get('/products/favorites');
  return response.data;
};

export const addToFavorites = async (product_id: number) => {
  const response = await apiClient.post(`/products/${product_id}/favorite`);
  return response.data;
};

export const removeFromFavorites = async (product_id: number) => {
  const response = await apiClient.delete(`/products/${product_id}/favorite`);
  return response.data;
};
